var GU = 8;
var RADIUS = 4;
var MEDIUM_RADIUS = 12;
var BIG_RADIUS = 16;

export { BIG_RADIUS, GU, MEDIUM_RADIUS, RADIUS };
